ExamSummaryFilter = new (function () {
  let examPairs = []; // [[title, academicalYear], ...]
  let updating = false;

  const parseSubjectYear = (value) => {
    if (!value) return {};
    const [subject, currentYear] = value.split(" - Year ");
    return { subject, currentYear };
  };

  const allTitles = () => [...new Set(examPairs.map(([title]) => title))].sort();
  const allYears = () => [...new Set(examPairs.map(([, year]) => year))].sort((a, b) => a - b);

  const yearsForTitle = (title) => {
    const years = examPairs.filter(([t]) => t === title).map(([, y]) => y);
    return [...new Set(years)].sort((a, b) => a - b);
  };

  const populateTitles = ($el, titles, selected) => {
    $el.empty();
    titles.forEach((t) => $el.append(new Option(t, t)));
    if (selected && titles.includes(selected)) $el.val(selected);
    $el.trigger("change");
  };

  const populateYears = ($el, years, selected) => {
    $el.empty();
    Shared.generateSelectOptions($el, years, true);
    const intSelected = parseInt(selected, 10);
    if (selected && years.includes(intSelected)) $el.val(intSelected);
    $el.trigger("change");
  };

  const withoutCascade = (fn) => {
    updating = true;
    fn();
    updating = false;
  };

  const fetchExamData = (subject, currentYear) => {
    const $title = $(".exam_summary_form #title");
    const $year = $(".exam_summary_form #academical_year");
    if (!$title.length) return;

    const apiParams = { is_in_class: true, select_column: "title_with_academical_year", is_subject_linked: true };
    if (subject) apiParams.subject = subject;
    if (currentYear) apiParams.current_year = currentYear;

    const prevTitle = $title.val() || new URLSearchParams(window.location.search).get("title");
    const prevYear = $year.val() || new URLSearchParams(window.location.search).get("academical_year");

    Shared.callApi({ url: `/results/autocomplete?${new URLSearchParams(apiParams)}` }).then((data) => {
      examPairs = Array.isArray(data) ? data : [];

      withoutCascade(() => populateTitles($title, allTitles(), prevTitle));

      const selectedTitle = $title.val();
      const years = selectedTitle ? yearsForTitle(selectedTitle) : allYears();
      withoutCascade(() => populateYears($year, years, prevYear));
    });
  };

  this.bindSubjectCurrentGroupEvents = () => {
    $(".submit_exams_summary").on("click", function () {
      const data = $(".exam_summary_form #subject_current_group_modal").val();
      if (!data) return;
      const { subject, currentYear } = parseSubjectYear(data);
      $(".exam_summary_form #current_year").val(currentYear);
      $(".exam_summary_form #subject").val(subject);
    });

    $(".exam_summary_form #subject_current_group_modal").on("change", function () {
      const { subject, currentYear } = parseSubjectYear($(this).val());
      fetchExamData(subject, currentYear);
    });

    $(".exam_summary_form #title").on("change", function () {
      if (updating) return;
      const $year = $(".exam_summary_form #academical_year");
      const selected = $(this).val();
      const years = selected ? yearsForTitle(selected) : allYears();
      withoutCascade(() => populateYears($year, years, $year.val()));
    });
  };

  this.setSelects = () => {
    $(".exam_summary_form #subject_current_group_modal").select2({
      allowClear: false,
    });

    $(".exam_summary_form #title").select2({
      placeholder: "Choose An Exam",
    });

    $(".exam_summary_form #academical_year").select2({
      minimumResultsForSearch: Infinity,
      allowClear: false,
    });

    const initialValue = $(".exam_summary_form #subject_current_group_modal").val();
    const { subject, currentYear } = parseSubjectYear(initialValue);
    fetchExamData(subject, currentYear);

    $(".exam-summary-wrapper #expectation_exam_summary_index").select2({
      minimumResultsForSearch: Infinity,
    });

    $(".exam-summary-wrapper #score_level_exam_summary_index").select2({
      minimumResultsForSearch: Infinity,
    });
  };
})();
